import { fontWeight, themeGet } from '@pocketlaw/tetris';
import styled, { css } from 'styled-components';
const commonListStyles = css `
  list-style-position: inside;

  &:not(:first-child) {
    margin-top: ${themeGet('spacing.md')};
  }
`;
export const UnorderedList = styled.ul `
  ${commonListStyles};
  list-style-type: disc;

  ul {
    padding-left: ${themeGet('spacing.md')};
  }

  p {
    display: contents;
  }
`;
export const OrderedList = styled.ol `
  ${commonListStyles};
  list-style: none;
  counter-reset: item;

  & > li:not(:empty) {
    counter-increment: item;
    display: flex;
    flex-flow: row nowrap;

    &::before {
      content: counters(item, '.');
      margin-right: ${themeGet('spacing.lg')};
      vertical-align: bottom;
      color: ${themeGet('colors.assistant.500')};
    }
  }

  & > li > ol > li:not(:empty)::before {
    content: counter(item, lower-alpha) ')';
  }
`;
export const ListItem = styled.li `
  &:not(:first-child) {
    margin-top: ${themeGet('spacing.md')};
  }
`;
export const Paragraph = styled.p `
  margin-top: ${themeGet('spacing.md')};

  &:first-child {
    margin-top: 0;
  }
`;
export const Strong = styled.strong `
  ${fontWeight('bold')};
`;
